// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import { BootstrapVue } from 'bootstrap-vue'

Vue.use(VueResource)

// Install BootstrapVue
Vue.use(BootstrapVue)

import { store } from '@/stores/BaseStore'
import FlashStore from '@/stores/FlashStore'

import { processErrors } from '@/services/PaApi'

Vue.config.productionTip = false

import saiApi from 'sai-vue-api'
Vue.use(saiApi)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  computed: {
    baseApiUrl () {
      const subdomain = this.hostname
      const host = [ subdomain + '-api' ].concat(
        window.location.host.split('.').slice(-2)
      )

      let url = 'https://' + host.join('.')
      if (window.location.hostname === 'localhost') {
        url = 'https://avxw-dev-api.ngrok.io'
        // url = 'https://avxw-api.standalone.com'
      }

      return url
    },

    defaultPageSize () {
      return 10
    },

    hostname () {
      let hostname = window.location.hostname
      let hn = hostname.split('.')

      if (hn[0] === 'admin') {
        return hn.slice(1).slice(-2)[0]
      } else {
        let subHostname = hn[0].split('-')
        let newHostname = subHostname[0]

        if (subHostname[1] === 'dev') {
          newHostname = newHostname + '-' + subHostname[1]
        }

        return newHostname
      }
    },

    env () {
      return process.env.NODE_ENV || 'devevelopment'
    },

    giftIcon () {
      return '🎁'
    },

    isDev () {
      return this.env === 'development'
    },

    listItemClasses () {
      return 'list-group-item list-group-item-action'
    },

    months () {
      return [
        'January', 'Februrary', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ]
    }
  },

  created () {
    this.redirectIfNecessary()
  },

  methods: {
    boolBadgeClass (bool) {
      let badgeClasses = ['badge']
      badgeClasses.push(
        bool ? 'btn-primary' : 'btn-danger'
      )

      return badgeClasses.join(' ')
    },

    boolText (bool) {
      return bool ? 'Yes' : 'No'
    },

    /*
      Global methods for date handling.
      (We don't use `moment` as it's overkill.)

      This should be moved to a separate plugin.
    */
    displayDateFmt (dateStr) {
      if (!dateStr) {
        return ''
      }

      const d = new Date(dateStr)

      return this.abbrMonth(d.getUTCMonth()) + ' ' + d.getUTCDate() + ', ' + d.getUTCFullYear()
    },

    displayDateLocalFmt (dateStr) {
      if (!dateStr) {
        return ''
      }

      const d = new Date(dateStr)

      return this.abbrMonth(d.getMonth()) + ' ' + d.getDate() + ', ' + d.getFullYear()
    },

    displayDateTimeFmt (dateStr) {
      if (!dateStr) {
        return ''
      }

      const d = new Date(dateStr)

      const dt = this.displayDateFmt(dateStr)

      return dt + ' ' + [
        this.zeropad(d.getUTCHours()),
        this.zeropad(d.getUTCMinutes()),
        this.zeropad(d.getUTCSeconds())
      ].join(':')
    },

    displayDateTimeLocalFmt (dateStr) {
      if (!dateStr) {
        return ''
      }

      const d = new Date(dateStr)

      const dt = this.displayDateLocalFmt(dateStr)

      return dt + ' ' + [
        this.zeropad(d.getHours()),
        this.zeropad(d.getMinutes()),
        this.zeropad(d.getSeconds())
      ].join(':')
    },

    downloadFile (ev) {
      const target = ev.target
      const mimetype = target.dataset.mimetype

      const headers = {}
      if (mimetype) { headers['Accept'] = mimetype }

      this.$http.get(ev.target.href, {
        headers: headers,
        responseType: 'blob'
      }).then((response) => {
        let headers = response.headers
        const filename = response.headers.get('filename')
        const str = response.bodyBlob
        const contentType = headers['Content-Type']

        this.downloadStr(str, filename, contentType)
      }, this.processErrors)
    },

    downloadStr (str, filename, contentType = 'application/octet-stream') {
      let blob = new Blob([str], {
        type: contentType
      })

      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = filename
      link.click()
    },

    abbrMonth (mon) {
      return this.month(mon).substr(0, 3)
    },

    month (mon) {
      return this.months[mon]
    },

    dateFmt (dateStr) {
      if (!dateStr) {
        return ''
      }

      const d = new Date(dateStr)

      return [
        d.getUTCFullYear(),
        this.zeropad(d.getUTCMonth() + 1),
        this.zeropad(d.getUTCDate())
      ].join('-')
    },

    prettyDateFmt (dateStr) {
      if (!dateStr) {
        return ''
      }

      const d = new Date(dateStr)

      return [
        this.zeropad(d.getUTCMonth() + 1),
        this.zeropad(d.getUTCDate()),
        d.getUTCFullYear()
      ].join('/')
    },

    prettyDateLocalFmt (dateStr) {
      if (!dateStr) {
        return ''
      }

      const d = new Date(dateStr)

      return [
        this.zeropad(d.getMonth() + 1),
        this.zeropad(d.getDate()),
        d.getFullYear()
      ].join('/')
    },

    // second-less implementation of dateTimeFmt.
    dateTimeLocalFmt (dateStr) {
      if (!dateStr) {
        return ''
      }

      const d = new Date(dateStr)

      return this.dateFmt(dateStr) + 'T' + [
        this.zeropad(d.getHours()),
        this.zeropad(d.getMinutes())
      ].join(':')
    },

    dateTimeFmt (dateStr) {
      if (!dateStr) {
        return ''
      }

      const d = new Date(dateStr)

      return this.dateFmt(dateStr) + ' ' + [
        this.zeropad(d.getUTCHours()),
        this.zeropad(d.getUTCMinutes()),
        this.zeropad(d.getUTCSeconds())
      ].join(':')
    },

    prettyDateTimeFmt (dateStr) {
      if (!dateStr) { return }

      return this.displayDateFmt(dateStr) + ' ' + this.pretty12HourMinFmt(dateStr)
    },

    prettyDateTimeLocalFmt (dateStr) {
      if (!dateStr) { return }

      return this.displayDateLocalFmt(dateStr) + ' ' + this.pretty12HourMinLocalFmt(dateStr)
    },

    pretty12HourMinFmt (dateStr) {
      if (!dateStr) {
        return ''
      }

      const d = new Date(dateStr)
      return [
        this.prettyHour(d),
        this.zeropad(d.getUTCMinutes())
      ].join(':') + ' ' + this.prettyTimeSuffix(d)
    },

    pretty12HourMinLocalFmt (dateStr) {
      if (!dateStr) {
        return ''
      }

      const d = new Date(dateStr)
      return [
        this.prettyHour(d, true),
        this.zeropad(d.getMinutes())
      ].join(':') + ' ' + this.prettyTimeSuffix(d, true)
    },

    /* Requires date object */
    localDateInputFmt (d) {
      return [
        d.getFullYear(),
        this.zeropad(d.getMonth() + 1),
        this.zeropad(d.getDate())
      ].join('-')
    },

    localTimeInputFmt (d) {
      return [
        this.zeropad(d.getHours()),
        this.zeropad(d.getMinutes())
      ].join(':')
    },

    getHours (d, local) {
      return local ? d.getHours() : d.getUTCHours()
    },

    timeIsMorning (d, local) {
      return this.getHours(d, local) <= 12
    },

    timeIsMidnight (d, local) {
      return this.getHours(d, local) === 0
    },

    prettyHour (d, local) {
      const hour = this.getHours(d, local)

      return this.timeIsMorning(d, local) ? (
        this.timeIsMidnight(d, local) ? 12 : hour
      ) : (hour - 12)
    },

    prettyTimeSuffix (d, local) {
      return this.timeIsMorning(d, local) ? 'AM' : 'PM'
    },

    downloadJSON (json, opts) {
      opts = opts || {}
      opts.downloadName = opts.downloadName || new Date().toUTCString() + '.json'

      let headers = {
        'Accept': 'application/json'
      }

      let blob = new Blob([
        JSON.stringify(json)
      ], {
        type: headers['Accept']
      })

      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = opts['downloadName']
      link.click()
    },

    /*
     * @deprecated Use SettingsModule's `brandings` instead.
     */
    getSetting (name) {
      const foundSetting = this.getSettings().filter((setting) => {
        return setting.name === name
      })

      if (foundSetting.length) {
        return foundSetting[0].val
      }
    },

    /*
     * @deprecated Use SettingsModule's `brandings` instead.
     */
    getSettings () {
      return JSON.parse(
        localStorage.getItem('settings') || '[]'
      )
    },

    isAdmin () {
      return this.currentUser.role_alias === 'admin'
    },

    zeropad (num) {
      return (num < 10 ? ('0' + num) : num)
    },

    setDate (dateStr) {
      const d = new Date(dateStr)

      const constructedDate = [
        d.getUTCFullYear(),
        this.zeropad(d.getUTCMonth() + 1),
        this.zeropad(d.getUTCDate())
      ].join('-')

      return constructedDate
    },

    capitalize (str) {
      return str.charAt(0).toUpperCase() + str.slice(1)
    },

    // Removes mailto: from strings for easier email searching.
    filterEmailSearchStr (str) {
      const mailtoRE = /^mailto:/i
      str = str.replace(mailtoRE, '')

      return str
    },

    humanize (str) {
      return this.capitalize(str).replace(/[-_]{1,}/g, ' ')
    },

    // Checks if location uses url fragments, and redirects if necessary.
    redirectIfNecessary () {
      if (window.location.pathname === '/' && window.location.hash.length > 0) {
        window.location.href = window.location.hash.substr(1)
      }
    },

    // Dispatching some events can interrupt modal closing,
    // so we remove modal-specific classes and elements here.
    forceCloseModal () {
      document.getElementsByTagName('body')[0].classList.remove('modal-open')
      document.getElementsByClassName('modal-backdrop')[0].remove()
    },

    // DO NOT confuse this with `processErrors` in `App`.
    // This is meant to eventually replace that method.
    processErrors (resp) {
      console.error('processErrors called in main.js', { ...resp })
      resp = resp.body ? { response: { data: resp.body } } : resp

      const err = processErrors(resp)

      this.$emit('showErrors', err)
      this.showFlash()
    },

    setFlashSuccess (result) {
      FlashStore.result(result)
      this.showFlash()
    },

    showFlash () {
      document.getElementById('flash').scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      })
    }
  }
})

// Clear flashes.
router.beforeEach((to, from, next) => {
  FlashStore.clear()
  next()
})



// WEBPACK FOOTER //
// ./src/main.js